module.exports = __webpack_public_path__ + "img/Disconnected Gateway Icon.2cf098d3.png";